export const LAYERS = {
  header: 50,
  /** Выпадающие меню хедера (портал) — выше панели AI Tutor, иначе чат перекрывает «Практика» / «Инструменты». */
  headerDropdown: 100,
  /** Выше FAB редактора (Lineage/схема ~z-30), но ниже modal и headerDropdown. */
  aiTutorPanel: 90,
  mobileOverlay: 40,
  mobileBackdrop: 39,
  mobileDrawer: 45,
  /** Общие модалки (в т.ч. модуль курса) — должны перекрывать AI Tutor. */
  modal: 140,
  /** Тема roadmap в модалке — выше панели AI Tutor и режима «развернуть» (z-200). */
  roadmapTopicModal: 220,
} as const;

